import { render, staticRenderFns } from "./MatchPanel.vue?vue&type=template&id=3be59bf9&scoped=true&"
import script from "./MatchPanel.vue?vue&type=script&lang=js&"
export * from "./MatchPanel.vue?vue&type=script&lang=js&"
import style0 from "./MatchPanel.vue?vue&type=style&index=0&id=3be59bf9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3be59bf9",
  null
  
)

export default component.exports